import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableRows } from "./TableRows.js";
import TableHeader from "./TableHeader.js";
export const Table = ({ data, columns, anchorBase, anchorKey, headerRowBackgroundClass, onRowClick, }) => {
    return (_jsxs("table", { className: "min-w-full divide-y", children: [_jsx(TableHeader, { columns: columns, headerRowBackgroundClass: headerRowBackgroundClass }), _jsx(TableRows, { data: data, columns: columns, anchorBase: anchorBase, anchorKey: anchorKey, onRowClick: onRowClick })] }));
};
